export const ACTIONS = <const>{
  AUTHORIZE_WITH_ACCESS_CODE: 'authorizeWithAccessCode'
}

export const MUTATIONS = {
  SET_UUID: 'setUuid',
  SET_ACCESS_TOKEN: 'setAccessToken'
}
